import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import $ from 'jquery';

const elementsToAnimate = [
    ".features-grid-bloc .feature",
    ".card-bloc .card",
    ".noma-sidebar-block .card",
    ".post-author-bloc .card",
    ".blog-post-bloc .card.not-appeared",
    ".banner-bloc .dark-blue-bg",
];

const toValues = {
    autoAlpha: 1,
    y:0,
    delay:0,
    ease: "power1.out",
    stagger: {
        each:0.15,
        onComplete: (el) => {
            console.log(this.targets()[0])
        }
    },
}

const init_animation = () => {
    if(elementsToAnimate.length){
        elementsToAnimate.forEach((selector) => {
            if($(selector).length){
                ScrollTrigger.batch(selector, {
                    onEnter: elements => {
                        return gsap.to(elements, {
                            autoAlpha: 1,
                            y:0,
                            delay:0,
                            ease: "power1.out",
                            stagger: {
                                each:0.15,
                                onComplete:function(){
                                    $(this.targets()[0]).removeClass("not-appeared");
                                    //fade out each target when it completes
                                    //gsap.to(this.targets()[0], {opacity:0})
                                }
                            },
                        })},
                    once: true
                });
            }
        })
    }
}


const removeClass = (e) => {
    console.log(e);
}

export {init_animation}